import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { bookingDetailsUrl, BOOKING_DETAILS_ACTION_TYPE, GET_BOOKING_DETAILS_ACTION_TYPE, getBookingDetailsUrl, deleteTableBookingDetailsUrl, DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE, GET_PRICE_AND_TIME_ACTION_TYPE, getPriceAndTimeUrl, headers, checkMeetingSlotsUrl, CHECK_MEETING_SLOTS_ACTION_TYPE } from "../../utils/constants"
import moment from 'moment';

export const booking_Details_action = (OrderID,
    TypeOfEventId, EntryTypeId, NoofPAX, SittingArrangementId,
    DeskId, currencyId, checkboxFlag, memershipFilePath,
    List, ClientID,
    formFile, formFileType, fileName, isEdit) => async (dispatch) => {
        try {
            const mapdata = {
                UserID: parseInt(sessionStorage.getItem('userId')),
                OrderID: OrderID != '' ? OrderID : null,
                TypeOfEventID: parseInt(TypeOfEventId) != '' ? parseInt(TypeOfEventId) : null,
                EntryTypeID: null,
                NoOfPAX: null,
                SittingTypeID: parseInt(SittingArrangementId) != '' ? parseInt(SittingArrangementId) : null,
                DeskTypeID: null,
                CurrencyID: currencyId != null ? currencyId : 1,
                Is_Membership: checkboxFlag,
                MembershipFilePath: memershipFilePath != '' ? memershipFilePath : null,
                BookingDetailsList: List,
                ClientID: ClientID != '' ? ClientID : null,
                FormFile: formFile != '' ? formFile : null,
                FormFileType: formFileType != '' ? formFileType : null,
                FileName: fileName != '' ? fileName : null,
                isEdit: isEdit != '' ? isEdit : 0,
            }
            console.log("data----------", mapdata)
            const res = await axiosPost(bookingDetailsUrl, mapdata, headers);

            dispatch({
                type: BOOKING_DETAILS_ACTION_TYPE,
                payload: res,
            });
            // console.log(res)

            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };


export const get_booking_Details_action = (orderId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')),
            OrderID: orderId
        }
        console.log("data----------**", mapdata)
        const res = await axiosGet(getBookingDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_BOOKING_DETAILS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delete_table_booking_Details_action = (orderDtlID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')) != '' ? parseInt(sessionStorage.getItem('userId')) : null,
            OrderDtlID: orderDtlID,
        };

        const res = await axiosGet(deleteTableBookingDetailsUrl, mapdata, headers);
        dispatch({
            type: DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getPriceAndTime_action = (CenterID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')) != '' ? parseInt(sessionStorage.getItem('userId')) : null,
            CenterID: CenterID,
        };

        const res = await axiosGet(getPriceAndTimeUrl, mapdata, headers);
        dispatch({
            type: GET_PRICE_AND_TIME_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const check_meeting_slots_action = (CenterID, OrderID, checkSlotList) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')),
            CenterID: CenterID,
            OrderID: OrderID,
            checkSlotList: checkSlotList
        }
        console.log("check_meeting_slots_action--", mapdata)
        const res = await axiosGet(checkMeetingSlotsUrl, mapdata, headers);

        dispatch({
            type: CHECK_MEETING_SLOTS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};